import React, { Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import classes from './MotorDataHPItems.css';
import ListItem from '../../UI/ListItems/SingleRowListItem/ListItem';
import LocalizedStrings from '../../../assets/data/LocalizedStrings/LocalizedStrings.json';

const createMotorURIElement = phase => {
  let URIelement = phase;
  URIelement = URIelement.replace(/\//g, '-');
  URIelement = URIelement.replace(/\s/g, '');
  return `/${URIelement}`;
};

const motorDataHPItems = props => {
  const { country, language } = props;
  const SinglePhase115V = require(`../../../assets/data/AppData/${country}/MotorData/SinglePhase/SinglePhase115V.json`),
    SinglePhase230V = require(`../../../assets/data/AppData/${country}/MotorData/SinglePhase/SinglePhase230V.json`),
    ThreePhase208V = require(`../../../assets/data/AppData/${country}/MotorData/ThreePhase/ThreePhase208V.json`),
    ThreePhase240V = require(`../../../assets/data/AppData/${country}/MotorData/ThreePhase/ThreePhase240V.json`),
    ThreePhase480V = require(`../../../assets/data/AppData/${country}/MotorData/ThreePhase/ThreePhase480V.json`),
    ThreePhase600V = require(`../../../assets/data/AppData/${country}/MotorData/ThreePhase/ThreePhase600V.json`);

  let title = `${LocalizedStrings[language].sp} 115V`,
    selectedPhase = '/motor-data/SP115V',
    phaseData = SinglePhase115V;

  switch (props.match.params.key) {
    case 'SP115V':
      title = `${LocalizedStrings[language].sp} 115V`;
      selectedPhase = '/motor-data/SP115V';
      phaseData = SinglePhase115V;
      break;
    case 'SP230V':
      title = `${LocalizedStrings[language].sp} 230V`;
      selectedPhase = '/motor-data/SP230V';
      phaseData = SinglePhase230V;
      break;
    case 'TP208V':
      title = `${LocalizedStrings[language].tp} 208V`;
      selectedPhase = '/motor-data/TP208V';
      phaseData = ThreePhase208V;
      break;
    case 'TP240V':
      title = `${LocalizedStrings[language].tp} 240V`;
      selectedPhase = '/motor-data/TP240V';
      phaseData = ThreePhase240V;
      break;
    case 'TP480V':
      title = `${LocalizedStrings[language].tp} 480V`;
      selectedPhase = '/motor-data/TP480V';
      phaseData = ThreePhase480V;
      break;
    case 'TP600V':
      title = `${LocalizedStrings[language].tp} 600V`;
      selectedPhase = '/motor-data/TP600V';
      phaseData = ThreePhase600V;
      break;
    default:
      title = `${LocalizedStrings[language].sp} 115V`;
      selectedPhase = '/motor-data/SP115V';
      phaseData = SinglePhase115V;
      break;
  }

  const selectedPhaseItems = Object.keys(phaseData);
  const phaseItems = [];
  Object.keys(selectedPhaseItems).forEach(i => {
    const item = (
      <Link
        key={selectedPhaseItems[i]}
        to={selectedPhase + createMotorURIElement(selectedPhaseItems[i])}
        style={{ textDecoration: 'none' }}
      >
        <ListItem title={selectedPhaseItems[i]} direction="next" />
      </Link>
    );

    phaseItems.push(item);
  });

  phaseItems.reduce((arr, el) => arr.concat(el), []);

  return (
    <Fragment>
      <ul className={classes.MotorDataHPItems}>{phaseItems}</ul>
      <div className={classes.TitleWrapper}>
        <h2>{title}</h2>
      </div>
    </Fragment>
  );
};


motorDataHPItems.propTypes = {
  language: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired
};


export default withRouter(motorDataHPItems);
